import { render, staticRenderFns } from "./PageBuilderLineBreakWidget.vue?vue&type=template&id=50a65bbc"
import script from "./PageBuilderLineBreakWidget.vue?vue&type=script&lang=js"
export * from "./PageBuilderLineBreakWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports